const allowedTypes = ['clubbing', 'concerts', 'festivals', 'students', 'conferences', 'seminar', 'shows', 'workshops', 'tradeshows', 'consumer_shows', 'test'];

export default function isPassCultureAllowed(eventType) {
    return allowedTypes.includes(eventType);
}
